import RepoTypeIcon from 'components/RepoTypeIcon';
import SummaryCard from 'components/SummaryCard';
import React from 'react';

import { HostType } from '../helper';

// SAMPLE DATA
// {
//   "id": 5,
//   "name": "Democlient-QA",
//   "branch": "main",
//   "account": {
//       "id": 2,
//       "title": "azure-devops/democlient@SecurePoint360.com",
//       "is_active": true,
//       "host_type": "azure",
//       "user": {
//           "id": 1265,
//           "first_name": "Salaar",
//           "last_name": "Khan",
//           "email": "skhan@securepoint360.com"
//       },
//       "token_info": {
//           "access_token_failed_attempts": 0,
//           "access_token_failed_reason": null
//       }
//   },
//   "status": "Scheduled",
//   "status_history": [
//       {
//           "date": "2024-03-22T06:09:35Z",
//           "status": "Scheduled",
//           "description": "Scan job scheduled."
//       },
//       {
//           "date": "2024-03-22T06:08:07Z",
//           "status": "Connected",
//           "description": "Connected By Salaar Khan."
//       }
//   ],
//   "added_by": {
//       "id": 1265,
//       "first_name": "Salaar",
//       "last_name": "Khan",
//       "email": "skhan@securepoint360.com"
//   },
//   "created_at": "2024-03-22T06:08:06.423412Z",
//   "deactivated_at": null,
//   "deactivated_by": null,
//   "is_active": true,
//   "last_commit_date": null,
//   "old_repo_id": null,
//   "slug": "",
//   "updated_at": "2024-03-22T06:08:06.710891Z",
//   "url": "https://democlient0412@dev.azure.com/democlient0412/Democlient-QA/_git/Democlient-QA",
//   "uuid": "dc4c5db5-4488-4e0d-b7bb-9acd1dac352a",
//   "scan": {
//       "id": 5,
//       "new_violations": 0,
//       "blocker_violations": 0,
//       "job_triggered_at": "2024-03-22T06:09:35.515248Z",
//       "is_manual_scan": false,
//       "vulnerabilities": 0,
//       "bugs_count": 0
//   },
//   "scan_in_progress": true,
//   "organization": "democlient0412",
//   "project": "Democlient-QA",
//   "project_id": null
// }

const RepoInfoSummary = ({ props, description, mode }) => {
  const {
    name,
    branch,
    status,
    url,
    scan_in_progress,
    organization,
    group_name,
    workspace,
    project,
    added_by,
    created_at,
  } = props;
  const hostType: HostType = props['account']['host_type'];

  const ownerName = `${added_by.first_name} ${added_by.last_name}`;

  const data = [
    { key: 'Name', value: name },
    { key: 'Branch', value: branch },
    { key: 'Status', value: status },
    { key: 'Scan In Progress', value: scan_in_progress ? 'Yes' : 'No' },
    hostType === HostType.Gitlab && { key: 'Group', value: group_name },
    hostType === HostType.Bitbucket && { key: 'Workspace', value: workspace },
    (hostType === HostType.Azure || hostType === HostType.Github) && {
      key: 'Organization',
      value: organization,
    },
    hostType === HostType.Azure && { key: 'Project', value: project },
    { key: 'Added By', value: ownerName },
    { key: 'Created At', value: created_at },
    { key: 'URL', value: url },
  ];

  return (
    <SummaryCard
      heading={props['name']}
      data={data}
      description={description}
      icon={<RepoTypeIcon repoType={props['account']['host_type']} size={48} />}
      mode={mode}
      //   iconClass="fa-brands fa-github" // Assuming you have corresponding icons in your icon library
    />
  );
};

export default RepoInfoSummary;
